
export const PIM_HISTORY_ACTION_TYPES = {
  SET_LOADING: 'PIM_HISTORY/SET_LOADING',
  SET_ERROR: 'PIM_HISTORY/SET_ERROR',
  SET_ENTRIES: 'PIM_HISTORY/SET_ENTRIES',
  SET_FILTERS: 'PIM_HISTORY/SET_FILTERS',
  RESET: 'PIM_HISTORY/RESET',
} as const;

export type PIMHistoryActionType = (typeof PIM_HISTORY_ACTION_TYPES)[keyof typeof PIM_HISTORY_ACTION_TYPES];
